import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { confirmAlert } from '../../utilityFunctions/confirmAlert';
import { toast } from 'react-toastify';
import { getCookies } from '../../hooks/useCookies';
import styles from './ToggleButton.module.scss';
import envValues from '../../enviornment';
import 'react-confirm-alert/src/react-confirm-alert.css';

const SECTION_STATUS_ENDPOINTS = {
  artist:  (id) => ({ url: `${envValues.REACT_APP_API_ENDPOINT}/artist/${id}/status`,  body: (active) => ({ is_active: active }), method: 'patch' }),
  appuser: (id) => ({ url: `${envValues.REACT_APP_API_ENDPOINT}/appuser/${id}/status`, body: (active) => ({ is_active: active }), method: 'patch' }),
};

const getApiErrorMessage = (err, fallback = 'Failed to update status.') =>
  err?.response?.data?.message || fallback;

const getStatusConfirmCopy = (sectionKey, willActivate) => {
  if (sectionKey === 'artist') {
    return willActivate
      ? {
        title: 'Activate this artist?',
        message: 'They will be able to log in and use the platform again.',
        confirmLabel: 'Activate',
      }
      : {
        title: 'Suspend this artist?',
        message: 'They will not be able to log in until the account is reinstated.',
        confirmLabel: 'Suspend',
      };
  }
  if (sectionKey === 'appuser') {
    return willActivate
      ? {
        title: 'Activate this app user?',
        message: 'The user will regain access to the app.',
        confirmLabel: 'Activate',
      }
      : {
        title: 'Suspend this app user?',
        message: 'The user will be blocked from using the app until reinstated.',
        confirmLabel: 'Suspend',
      };
  }
  return willActivate
    ? {
      title: 'Activate account?',
      message: 'Do you want to activate this account?',
      confirmLabel: 'Activate',
    }
    : {
      title: 'Deactivate account?',
      message: 'Do you want to deactivate this account?',
      confirmLabel: 'Deactivate',
    };
};

function ToggleButtonOnOff({ value, id, section }) {
  const [isOff, setIsOff] = useState(false);
  const token = `Bearer ${getCookies('Token')}`;

  useEffect(() => {
    setIsOff(value);
  }, [value]);

  const handleToggleIntent = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const sectionKey = section ? section.replace(/\s+/g, '').toLowerCase() : null;
    const nextValue = !isOff;
    const willActivate = nextValue;
    const { title, message, confirmLabel } = getStatusConfirmCopy(sectionKey, willActivate);

    confirmAlert({
      title,
      message,
      buttons: [
        {
          label: 'Cancel',
          onClick: () => {},
        },
        {
          label: confirmLabel,
          onClick: () => {
            setIsOff(nextValue);

            const endpointDef = sectionKey && SECTION_STATUS_ENDPOINTS[sectionKey]
              ? SECTION_STATUS_ENDPOINTS[sectionKey](id)
              : null;

            if (endpointDef) {
              const headers = { Authorization: token };
              const request = endpointDef.method === 'patch'
                ? axios.patch(endpointDef.url, endpointDef.body(nextValue), { headers })
                : axios.post(endpointDef.url, endpointDef.body(nextValue), { headers });
              request
                .then(() => toast.success(`Status ${nextValue ? 'activated' : 'deactivated'} successfully.`))
                .catch((err) => {
                  setIsOff(!nextValue);
                  toast.error(getApiErrorMessage(err));
                });
            } else {
              const headers = { 'Content-Type': 'application/json; charset=utf-8' };
              const body = { token: getCookies('Token'), userid: id, active: nextValue };
              axios.post(`${envValues.REACT_APP_API_ENDPOINT}/auth/toggle-change`, body, headers)
                .then(() => toast.success(`Status ${nextValue ? 'activated' : 'deactivated'} successfully.`))
                .catch((err) => {
                  setIsOff(!nextValue);
                  toast.error(getApiErrorMessage(err));
                });
            }
          },
        },
      ],
    });
  };
  return (
    <div className="col ">
      <label className={styles.switch}>
        <input
          type="checkbox"
          role="switch"
          aria-checked={isOff}
          checked={isOff}
          onChange={handleToggleIntent}
        />
        <span className={styles.slider} />
      </label>
    </div>
  );
}

ToggleButtonOnOff.propTypes = {
  value: PropTypes.bool,
  id: PropTypes.string,
  section: PropTypes.string,
};
ToggleButtonOnOff.defaultProps = {
  value: false,
  id: null,
  section: null,
};
export default ToggleButtonOnOff;
